import React,{ useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Customer from "../Modals/Customer";
import OrganizationAxiosInstance from "../Services/OrganizationAxiosInstance";  // Adjust this import as needed
import Spinner from "../Components/Spinner";
import Error from "../Components/Error";

import { FaRegUser } from "react-icons/fa";
import SubUser from "../Modals/SubUser";
import { Bounce, toast } from "react-toastify";
import { isAxiosError } from "axios";
import { useTranslation } from "react-i18next";
const SubUsers: React.FC = () => {
  const { id } = useParams<{ id: string }>();  // PassTemplate ID
  const [SubUsers, setSubUsers] = useState<SubUser[]>([]);
  const [refresh,setRefresh] = useState(0)
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [modalHidden, setModalHidden] = useState(true);
  const [editModalHidden, setEditModalHidden] = useState(true);

  const {t} = useTranslation()
  const [subUser,setSubUser] = useState<SubUser>({
    id:"",
    name:"",
    email:"",
    password:"",
    passTemplate:undefined,
    passTemplateId:id});

    const [editSubUser,setEditSubUser] = useState<SubUser>({
    id:"",
    name:"",
    email:"",
    password:"",
    passTemplate:undefined,
    passTemplateId:id});


  useEffect(() => {
    const fetchSubUsers = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await OrganizationAxiosInstance.get(`/PassTemplate/${id}/SubUsers`);

        setSubUsers(response.data);
       
      } catch (error) {
        setError("Failed to load SubUsers");
      } finally {
        setLoading(false);
      }
    };

    fetchSubUsers();
  }, [id,refresh]);

  const addSubuser = async ()=>{
    setModalHidden(true)
    const toastId  = toast.loading("💌 Adding User",{
      position: "top-right",
      theme: "light",
      isLoading:true,
      transition: Bounce
    })
    try {
      const response = await OrganizationAxiosInstance.post(`/Organization/add-subuser`,subUser)
      if(response.status==200){
        toast.update(toastId, {
          render: "👌 User Added successfully",
          type: "success",
          isLoading: false,
          autoClose:3000
      })

      }
    } catch (error) {
        if(isAxiosError(error)){
          toast.update(toastId, {
            render: error.response?.data.error,
            type: "error",
            isLoading: false,
            autoClose:3000
        })
        }
    }finally{
      setSubUser({
        id:"",
        name:"",
        email:"",
        password:"",
        passTemplate:undefined,
        passTemplateId:undefined})
    }
    setRefresh(refresh+1)
  }

  

   const editSubuser = async ()=>{
    setModalHidden(true)
    const toastId  = toast.loading("💌 Updating User",{
      position: "top-right",
      theme: "light",
      isLoading:true,
      transition: Bounce
    })
    try {
      const response = await OrganizationAxiosInstance.post(`/Organization/edit-subuser/${editSubUser.id}`,editSubUser)
      if(response.status==200){
        toast.update(toastId, {
          render: "👌 User Updated successfully",
          type: "success",
          isLoading: false,
          autoClose:3000
      })

      }
    } catch (error) {
        if(isAxiosError(error)){
          toast.update(toastId, {
            render: error.response?.data.error,
            type: "error",
            isLoading: false,
            autoClose:3000
        })
        }
    }finally{
      setEditSubUser({
        id:"",
        name:"",
        email:"",
        password:"",
        passTemplate:undefined,
        passTemplateId:undefined})
    }
    setEditModalHidden(true)
    setRefresh(refresh+1)
  }

  return loading ? (
    <Spinner size={70} loading={loading} />
  ) : error ? (
    <Error message={error} />
  ) : (
    <div className="h-[100%]  flex flex-col">
      {/* Main content wrapper */}
      <div className="flex h-[100%] flex-col justify-between overflow-auto p-4">
        <div>
        <div className="flex justify-end">
        <button onClick={()=>{
                                setModalHidden(false)
                            }}   className="text-white bg-brand-600 w-full md:w-fit hover:bg-brand-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center :text-white  :focus:ring-primary-900">Add SubUser</button>
        </div>
       
        <div className="flex-grow min-h-[80vh] md:min-h-[88vh] overflow-auto pt-4">
          <div className="w-full">
        {/* Mobile: stacked cards */}
        <div className="sm:hidden space-y-3">
          {SubUsers.map((SubUser) => (
            <div
              key={SubUser.id}
              className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm"
            >
              <div className="flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-50">
                  <FaRegUser className="h-6 w-6 text-brand-600" />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-gray-900 truncate">
                    {SubUser.name}
                  </div>
                  <div className="text-xs text-gray-500 truncate">
                    {SubUser.email}
                  </div>
                </div>
              </div>

              <div className="mt-3 grid grid-cols-2 gap-y-2">
                <div className="text-xs text-gray-500">{t("program")}</div>
                <div className="text-right text-sm text-gray-900">
                  {SubUser.passTemplate?.name ?? "-"}
                </div>
              </div>

              <div className="mt-4">
                <button
                  onClick={() => {
                    setEditSubUser({
                      id: SubUser.id,
                      name: SubUser.name,
                      email: SubUser.email,
                      password: "", // empty = keep the current password
                      passTemplate: undefined,
                      passTemplateId: SubUser.passTemplateId,
                    });
                    setEditModalHidden(false);
                  }}
                  className="inline-flex w-full items-center justify-center rounded-lg bg-brand-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-brand-300"
                >
                  {t("update")}
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Desktop/Tablet: table view */}
        <table className="hidden sm:table min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {t("name")}
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {t("program")}
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                -
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {SubUsers.map((SubUser) => (
              <tr key={SubUser.id} className="bg-white border-b border-gray-200">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="flex h-15 w-15 flex-col justify-center">
                      <FaRegUser className="text-brand-600" />
                    </div>
                    <div className="mx-4">
                      <div className="text-sm font-medium text-gray-900">
                        {SubUser.name}
                      </div>
                      <div className="text-sm text-gray-500">{SubUser.email}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900">
                    {SubUser.passTemplate?.name}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm">
                  <button
                    onClick={() => {
                      setEditSubUser({
                        id: SubUser.id,
                        name: SubUser.name,
                        email: SubUser.email,
                        password: SubUser.password,
                        passTemplate: undefined,
                        passTemplateId: SubUser.passTemplateId,
                      });
                      setEditModalHidden(false);
                    }}
                    className="text-white bg-brand-600 hover:bg-brand-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 py-2.5"
                  >
                    {t("update")}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

        </div>
        </div>
        <div id="crud-modal" tabIndex={-1} aria-hidden="true" className={`${modalHidden?"hidden":""} overflow-y-auto overflow-x-hidden fixed top-0 left-0 z-50  w-full  max-h-full`}>
            <div className="flex bg-gray-600 bg-opacity-90 w-[100%] h-[100vh] justify-center items-center">
            <div className="relative py-1 px-4 w-full max-w-xl max-h-full">
       
       <div className="relative bg-white min-h-[500px]  overflow-auto rounded-lg shadow -gray-700">
           <div className="flex items-center justify-between p-3 md:p-3 border-b rounded-t -gray-600">
               <h3 className="text-lg font-semibold text-gray-900 -white">
                   {t("addSubUser")}
               </h3>
               <button type="button"  onClick={()=>{
                       setModalHidden(true)
                   }} className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center hover:bg-gray-600 hover:text-white" data-modal-toggle="crud-modal">
                   <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                       <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                   </svg>
                   <span className="sr-only">Close modal</span>
               </button>
           </div>

     
           <div className="flex flex-col justify-center items-center py-16 px-10">
                   {/* {selectedPlan?<CreditCardForm plan={selectedPlan} />:"No plan selected"} */}
                  
                   <div className="mb-5">
            <label
              htmlFor="name"
              className="block mb-2 text-sm font-medium text-gray-900 -white"
            >
              {t("name")}
            </label>
            <input
              type="text"
              id="name"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 -gray-700 -gray-600 placeholder-gray-400 -white focus:ring-blue-500 focus:border-blue-500"
              placeholder="Jason Born"

              onChange={(e) =>
                setSubUser({ ...subUser, name: e.target.value })
              }
            />
          </div>
          <div className="mb-5">
            <label
              htmlFor="email"
              className="block mb-2 text-sm font-medium text-gray-900 -white"
            >
              {t("email")}
            </label>
            <input
              type="email"
              id="email"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 -gray-700 -gray-600 placeholder-gray-400 -white focus:ring-blue-500 focus:border-blue-500"
              placeholder="name@roaait.com"
              onChange={(e) =>
                setSubUser({ ...subUser, email: e.target.value })
              }
            />
           
          </div>

          <div className="mb-5">
          <label
              htmlFor="password"
              className="block mb-2 text-sm font-medium text-gray-900 -white"
            >
              {t("password")}
            </label>
              <input
              type="password"
              id="password"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 -gray-700 -gray-600 placeholder-gray-400 -white focus:ring-blue-500 focus:border-blue-500"
              placeholder="*********"
              onChange={(e) =>
                setSubUser({ ...subUser, password: e.target.value })
              }
            />
          </div>

          <div className="mb-5">
          <button
            type="button"
            className="text-white bg-brand-600 hover:bg-brand-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center -blue-600 hover:bg-blue-700 focus:ring-blue-800"
              onClick={()=>{
                addSubuser()
              }}
          >
            {t("add")}
          </button>
          </div>
           </div>
         
                      
          </div>
   </div>
            </div>
 
          </div>
        
        <div id="crud-modal" tabIndex={-1} aria-hidden="true" className={`${editModalHidden?"hidden":""} overflow-y-auto overflow-x-hidden fixed top-0 left-0 z-50  w-full  max-h-full`}>
            <div className="flex bg-gray-600 bg-opacity-90 w-[100%] h-[100vh] justify-center items-center">
            <div className="relative py-1 px-4 w-full max-w-xl max-h-full">
       
       <div className="relative bg-white min-h-[500px]  overflow-auto rounded-lg shadow -gray-700">
           <div className="flex items-center justify-between p-3 md:p-3 border-b rounded-t -gray-600">
               <h3 className="text-lg font-semibold text-gray-900 -white">
                   {t("editSubUser")}
               </h3>
               <button type="button"  onClick={()=>{
                       setEditModalHidden(true)
                   }} className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center hover:bg-gray-600 hover:text-white" data-modal-toggle="crud-modal">
                   <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                       <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                   </svg>
                   <span className="sr-only">Close modal</span>
               </button>
           </div>

     
           <div className="flex flex-col justify-center items-center py-16 px-10">
                   {/* {selectedPlan?<CreditCardForm plan={selectedPlan} />:"No plan selected"} */}
                  
                   <div className="mb-5">
            <label
              htmlFor="edit-name"
              className="block mb-2 text-sm font-medium text-gray-900 -white"
            >
              {t("name")}
            </label>
            <input
              type="text"
              id="edit-name"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 -gray-700 -gray-600 placeholder-gray-400 -white focus:ring-blue-500 focus:border-blue-500"
              placeholder="Jason Born"
              value={editSubUser.name}
              onChange={(e) =>
                setEditSubUser({ ...editSubUser, name: e.target.value })
              }
            />
          </div>
          <div className="mb-5">
            <label
              htmlFor="edit-email"
              className="block mb-2 text-sm font-medium text-gray-900 -white"
            >
              {t("email")}
            </label>
            <input
              type="email"
              id="edit-email"
              value={editSubUser.email}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 -gray-700 -gray-600 placeholder-gray-400 -white focus:ring-blue-500 focus:border-blue-500"
              placeholder="name@roaait.com"
              onChange={(e) =>
                setEditSubUser({ ...editSubUser, email: e.target.value })
              }
            />
           
          </div>

          <div className="mb-5">
          <label
              htmlFor="edit-password"
              className="block mb-2 text-sm font-medium text-gray-900 -white"
            >
              {t("password")}
            </label>
              <input
              type="password"
              id="edit-password"
              value={editSubUser.password ?? ""}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 -gray-700 -gray-600 placeholder-gray-400 -white focus:ring-blue-500 focus:border-blue-500"
              placeholder={t("keepCurrentPassword")}
              onChange={(e) =>
                setEditSubUser({ ...editSubUser, password: e.target.value })
              }
            />
          </div>

          <div className="mb-5">
          <button
            type="button"
            className="text-white bg-brand-600 hover:bg-brand-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center -blue-600 hover:bg-blue-700 focus:ring-blue-800"
              onClick={()=>{
                editSubuser()
              }}
          >
            {t("add")}
          </button>
          </div>
           </div>
         
                      
          </div>
   </div>
            </div>
 
          </div>
      </div>

    </div>
  );
  


}

export default SubUsers;
